import styled from 'styled-components';
import filter_arrow from '../../../assets/image/filter_arrow.png';
import filter_arrow_selected from '../../../assets/image/filter_arrow_selected.png';
import sort_arrow_up from '../../../assets/image/sort_arrow_up.png';
import sort_arrow_down from '../../../assets/image/sort_arrow_down.png';
import default_sort_arrow from '../../../assets/image/default_sort_arrow.png';
import {borderTop1px} from "../../../utils/style/mixin";

const Container = styled.div`
position: relative;
width: 100%;
z-index: 234 !important;
height: 1.2rem;
background-color:#fff;
display: flex;
z-index: 100;
&.fixed {
position: fixed;
top: 0;
left: 0;
right: 0;
}
.condition-item {
position: absolute;
top: 1.2rem;
left: 0;
right: 0;
}
`

const ItemContainer = styled.div`
position: relative;
width: 25%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
.filter-content {
display: flex;
align-items: center;
height: 100%;
max-width: 80%;
overflow: hidden;
white-space:nowrap;
word-break: break-all;
overflow: hidden;
text-overflow: ellipsis;
font-size: 0.28rem;
color: #0b1b2f;
margin-right: .08rem;
&.actived {
color: #cc2729;
}
.selected_filter_indicator {
color: #cc2729;
}
.filter_sort_top {
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${sort_arrow_up}") no-repeat;
background-size: auto 100%;
}
.filter_sort_down{
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${sort_arrow_down}") no-repeat;
background-size: auto 100%;
}
}

.filter_sort_default{
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${default_sort_arrow}") no-repeat;
background-size: auto 100%;
}

.filter-indicator {
display: inline-block;
width: 0.18rem;
height: 0.12rem;
background: url("${filter_arrow}") no-repeat;
background-size: .18rem .12rem;
&.actived {
background: url("${filter_arrow_selected}") no-repeat;
background-size: .18rem .12rem;
}
}

`

const SortContainer = styled.div`
background-color:#fff;
ul {
li {
font-size: .3rem;
padding: .24rem .2rem;
border-bottom: 1px solid #f3f4f5;
letter-spacing: .01rem;
&.actived {
color: #cc2729;
}
}
}
`

const ClassifyContainer = styled.div`
background-color:#fff;
.classify-content {
padding: 0 .2rem;
display: flex;
flex-wrap: wrap;
margin-right: -0.3rem;
.classify-item {
display: flex;
justify-content: center;
align-items: center;
width: 2.1rem;
margin-right: 0.3rem;
padding: 0.13rem 0.05rem;
background-color: #f0f2f5;
border-radius: 0.03rem;
font-size: 0.24rem;
color: #433e33;
margin-bottom: 0.3rem;
line-height: 0.34rem;
&.actived {
background-color: #cc2729;
color: #fff;
}
}
.none {
border: none;
background: rgba(0,0,0,0);
}
}
`

const LocationContainer = styled.div`
-webkit-overflow-scrolling: touch;
height: 8.6rem;
background-color:#fff;
.province-container {
height: 100%;
position: absolute;
overflow-y: scroll;
overflow-x: hidden;
.province-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
font-size: 0.3rem;
color: #0b1b2f;
&.active {
background-color:#fff;
color: #cc2729;
}
}
}

.city-container {
background-color:#fff;
width: 100%;
height: 100%;
position: absolute;
left: 1.8rem;
overflow-y: scroll;
overflow-x: hidden;
font-size: 0.3rem;
.city-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
&.active {
background-color:#fff;
color: #cc2729;
}
}
}

.county-container {
width: 100%;
height: 100%;
position: absolute;
left: 3.6rem;
overflow-y: scroll;
overflow-x: hidden;
font-size: 0.3rem;
.county-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
&.active {
background-color:#fff;
color: #cc2729;
}
}
}
`
const MoreContainer = styled.div`
font-size: .3rem;
background-color:#fff;
.title-card {
margin-bottom: .4rem;
padding: 0 .3rem;
.title{
font-size: 0.28rem;
}
.content {
display: flex;
flex-wrap: wrap;
margin-right: -0.3rem;
.filter-item {
display: flex;
justify-content: center;
align-items: center;
width: 2.1rem;
margin-right: 0.3rem;
padding: 0.13rem 0.05rem;
background-color: #f0f2f5;
border-radius: 0.03rem;
font-size: 0.24rem;
color: #433e33;
margin-top: 0.3rem;
line-height: 0.34rem;
&.actived {
background-color: #cc2729;
color: #fff;
}
&.empty {
background-color:#fff;
}
}
}
}

.group-container {
height: 0.8rem;
margin-top: .3rem;
display: flex;
.btn-item {
flex: 1;
display: flex;
justify-content: center;
align-items: center;
font-size: 0.28rem;
line-height: 0.8rem;
color: #0b1b2f;
${borderTop1px({borderTcolor:'#EEE'})};
}
.reset {
}
.confirm{
background-color: #cc2729;
color: #fff;
${borderTop1px({borderTcolor:'#cc2729'})};
}
}
`
export {
Container,
ItemContainer,
SortContainer,
ClassifyContainer,
LocationContainer,
MoreContainer,
}
